export default class ThemeTrendService {
  getAll() {
    return fetch("https://api.tradersr.com/api/themetrend")
      .then(res => res.json());
  }
}